export default "__VITE_ASSET__Dh1RJWSD__"